<div [formGroup]="ticketForm">
    <div class="flex gap-3 relative mb-3">
        <p-select [options]="ticketTypes$ | async" placeholder="Select a ticket type" class="small w-1/2" formControlName="ticketType" (onChange)="onSelectChange($event)"/>
        <p-inputNumber mode="currency" formControlName="ticketCost" currency="GBP" />
    </div>
    <div class="mb-3 flex flex-col w-full">
        <label for="description">Description</label>
        <input type="text" name="description" formControlName="description" />
    </div>
    @if (cateringTickets.includes(ticketForm.controls['ticketType'].value)){
        <div class="mb-3 flex flex-col w-full">
            <label for="caterer">Caterer</label>
            <input type="text" name="caterer" formControlName="caterer" placeholder="Your caterers trading name" />
        </div>
    }
    <div class="flex gap-3 mb-3">
        <div class="flex flex-col gap-2 w-40 mb-3">
            <label for="startDate">Available From</label>
            <input type="date" name="startDate" formControlName="availableFrom" />
        </div>
        <div class="flex flex-col gap-2 w-40 mb-3">
            <label for="endDate">Available To</label>
            <input type="date" name="endDate" formControlName="availableTo" [min]="ticketForm.controls['availableFrom'].value" >
        </div>
        <div class="flex flex-col justify-end ps-4 mb-3">
            <button class="primaryButton button-small" [disabled]="!ticketForm.valid" (click)="addTicket()"><fa-icon [icon]="['fas','circle-plus']" class="me-2" />Add Ticket</button>
        </div>
    </div>
    @if (showTicketList){
        @for(ticket of lrpEvent.eventTickets; track $index){
            <div class="grid grid-cols-4 gap-4 text-sm">
                <div>{{ ticket.name }}</div>
                <div>{{ ticket.cost | currency:'GBP' }}</div>
                <div class="col-span-2">{{ ticket.availableFrom | date }} - {{ ticket.availableTo | date }}</div>
            </div>
        }
    }
</div>
